import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {VehiclePathResponse} from '../../pages/client/monitor/tacho/model/vehicle-path-response';
import {UntypedFormGroup} from "@angular/forms";
import {TachoLatestEntry} from "../model/tacho/tacho-latest.entry";
import {VehicleTachoChartEntry} from '../model/tacho/vehicle-echart/model/vehicle-tacho-chart.entry';

@Injectable()
export class GlobalTachoService {

  constructor(private http: HttpClient) {
  }

  public getLatestTacho(
    driverCards: string[],
    fromTill: UntypedFormGroup,
    vehicle: number,
    skipLoader: boolean): Observable<TachoLatestEntry> {

    let from = fromTill.get('from')?.value;
    let till = fromTill.get('till')?.value;
    let headers = skipLoader ? {headers: {skip: 'true'}} : {};
    return this.http.get<TachoLatestEntry>(
      `/api/tachograph/latest-info/${vehicle}/${from}/${till}?driverCards=${driverCards.join(',')}`,
      headers
    );
  }

  public getVehicleChart(
      vehicleId: number,
      fromTill: UntypedFormGroup,
      skipLoader: boolean): Observable<VehicleTachoChartEntry> {

    let from = fromTill.get('from')?.value;
    let till = fromTill.get('till')?.value;
    let headers = skipLoader ? {headers: {skip: 'true'}} : {};
    return this.http.get<VehicleTachoChartEntry>(
        `/api/tachograph/vehicle-chart/${vehicleId}/${from}/${till}`,
        headers
    );
  }

  public getPosition(driverCard: string,
                     startTime: number,
                     endTime: number,
                     vehicleId: number): Observable<VehiclePathResponse> {

    return this.http.get<VehiclePathResponse>(
      `/api/tachograph/vehicle-path/${driverCard}/${startTime}/${endTime}?vehicleId=${vehicleId}`);
  }
}
